export enum GridMode {
    UNDEFINED = 0,
    ON_GRID = 1,
    OFF_GRID = 2,
}
export enum Mode {
    MANUAL_ON = 'MANUAL_ON',
    MANUAL_OFF = 'MANUAL_OFF',
    AUTOMATIC = 'AUTOMATIC',
}
export enum WorkMode {
    TIME = 'TIME',
    NONE = 'NONE',
}
